import React from 'react';

import { Box, Flex, Section2 } from 'components';
import useOffers from 'features/offers/useOffers';
import { PaymentsHeader, PaymentsSafeBuyFooter, PaymentsSidebar } from 'features/offers';

interface NoImageProps {
  children: React.ReactNode;
}

const NoImage = ({ children }: NoImageProps) => {
  const { buyInformation } = useOffers();

  return (
    <Flex minWidth="100vw" minHeight="100vh" flexDirection="column" alignItems="flex-start" bg={buyInformation?.backgroundColor}>
      <PaymentsHeader />

      <Section2
        maxWidth={{ m: '90%', d: 940 }}
        alignItems="flex-start"
        justifyContent="space-between"
        mt={{ d: 3 }}
        flexDirection={{ m: 'column-reverse', d: 'row' }}
      >
        <Box flexGrow={0} flexShrink={0} width={{ m: '100%', d: 620 }}>
          {children}

          <Box mt={{ m: 3, d: 4 }} mb={5}>
            <Box display={{ m: 'block', d: 'none' }} mb={4}>
              <PaymentsSafeBuyFooter freeOffer={buyInformation?.freeOffer} />
            </Box>
          </Box>
        </Box>

        <PaymentsSidebar />
      </Section2>
    </Flex>
  );
};

export default NoImage;
